<template>
    <vx-expandable-card>
        <template v-slot:content>
            <div class="flex flex-col gap-4">
                <div>
                    <vx-label size="md">Group</vx-label>
                    <select-group placeholder="-"
                        v-model="model"
                        size="lg"
                        :clearable="true"
                        :statuses="GROUP_STATUSES_CONFIGURABLE">
                    </select-group>
                </div>
            </div>
        </template>
    </vx-expandable-card>
</template>
<script setup>
import {
    VxExpandableCard,
    VxLabel,
} from '@voxie/frontend-components';
import SelectGroup from '~/components/general/SelectGroup.vue';
import { GROUP_STATUSES_CONFIGURABLE } from '~/constants/groupStatuses';

const model = defineModel({
    type: String,
    required: false,
});
</script>
